import React, { useEffect, useState } from "react";
import { getElternvereinPage } from "../lib/api";
import { Page, PageHeader, Section, IntroSplit, FactList } from "../components/ui";
import "../styles/ElternvereinPage.css";

export default function ElternvereinPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getElternvereinPage()
      .then((res) => !cancelled && setData(res))
      .catch((err) => !cancelled && setError(err));
    return () => {
      cancelled = true;
    };
  }, []);

  const {
    heroTitle,
    heroSubtitle,
    boardPhoto,
    introKicker,
    introTitle,
    introText1,
    introText2,
    membershipBadgeLabel,
    membershipBadgeValue,
    benefitsTitle,
    benefitsSubtitle,
    benefits,
    howTitle,
    howText1,
    howText2,
    howText3,
    howFacts,
    contactTitle,
    contactText,
    contactEmail,
    contactExternalUrl,
    contactExternalLabel,
    bankFacts,
  } = data || {};

  return (
    <Page loading={!data} error={error}>
      <PageHeader
        parent={{ label: "Eltern & Schule", to: "/mitgestalten" }}
        current="Elternverein"
        title={heroTitle}
        subtitle={heroSubtitle}
      />

      <Section intro>
        <IntroSplit
          image={boardPhoto}
          alt="Vorstand des Elternvereins"
          kicker={introKicker}
          title={introTitle}
          text={[introText1, introText2]}
          after={
            membershipBadgeLabel ? (
              <div className="ev-badge">
                <span>{membershipBadgeLabel}</span>
                <strong>{membershipBadgeValue}</strong>
              </div>
            ) : null
          }
        />
      </Section>

      {/* Numbered task cards — a shape only this page uses. */}
      <Section>
        <div className="ev-split-title">
          <div>
            <h2>{benefitsTitle}</h2>
          </div>
          <p>{benefitsSubtitle}</p>
        </div>

        <div className="ev-task-grid">
          {(benefits || []).map((item, index) => (
            <article className="ev-task" key={index}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <p>{item}</p>
            </article>
          ))}
        </div>
      </Section>

      {/* Text + FactList side by side. */}
      <Section>
        <div className="ev-how">
          <div className="ev-how__text">
            <h2>{howTitle}</h2>
            {howText1 ? <p>{howText1}</p> : null}
            {howText2 ? <p>{howText2}</p> : null}
            {howText3 ? <p>{howText3}</p> : null}
          </div>
          <FactList facts={howFacts} defaultIcon="check" />
        </div>
      </Section>

      <Section>
        <div className="ev-contact">
          <div className="ev-contact__text">
            <h2>{contactTitle}</h2>
            <p>{contactText}</p>
            <div className="ev-contact__links">
              {contactEmail ? <a href={`mailto:${contactEmail}`}>{contactEmail}</a> : null}
              {contactExternalUrl ? (
                <a href={contactExternalUrl} target="_blank" rel="noreferrer">
                  {contactExternalLabel || contactExternalUrl}
                </a>
              ) : null}
            </div>
          </div>
          <FactList facts={bankFacts} defaultIcon="building-2" />
        </div>
      </Section>
    </Page>
  );
}